import { Type } from '@sinclair/typebox';
import { SupportedDexSchema } from './supported-dex.js';
import { SupportedNetworkSchema } from './supported-network.js';
import { TradeSettingsUnionSchema } from './trade/swap.js';
export var LimitOrderTriggerType;
(function (LimitOrderTriggerType) {
    LimitOrderTriggerType["Absolute"] = "absolute";
    LimitOrderTriggerType["MarketCap"] = "market-cap";
})(LimitOrderTriggerType || (LimitOrderTriggerType = {}));
export const LimitOrderTriggerTypeSchema = Type.Enum(LimitOrderTriggerType, {
    title: 'TradeLimitOrderType',
    description: 'Type of trigger for the limit order',
    type: 'string',
    enum: ['absolute', 'market-cap'],
});
export var LimitOrderType;
(function (LimitOrderType) {
    LimitOrderType["Buy"] = "buy";
    LimitOrderType["Sell"] = "sell";
})(LimitOrderType || (LimitOrderType = {}));
export const LimitOrderTypeSchema = Type.Enum(LimitOrderType, {
    type: 'string',
    enum: ['buy', 'sell'],
});
export var LimitOrderStatus;
(function (LimitOrderStatus) {
    LimitOrderStatus["Active"] = "active";
    LimitOrderStatus["Cancelled"] = "cancelled";
    LimitOrderStatus["Completed"] = "completed";
    LimitOrderStatus["Expired"] = "expired";
    LimitOrderStatus["Failed"] = "failed";
})(LimitOrderStatus || (LimitOrderStatus = {}));
export const LimitOrderStatusSchema = Type.Enum(LimitOrderStatus, {
    type: 'string',
    enum: ['active', 'cancelled', 'completed', 'expired', 'failed'],
});
export const LimitOrderTriggerSchema = Type.Object({
    triggerType: Type.Enum(LimitOrderTriggerType),
    valueHigh: Type.Optional(Type.String()),
    valueLow: Type.Optional(Type.String()),
});
export const LimitOrderSchema = Type.Object({
    id: Type.String(),
    delugeId: Type.String(),
    type: LimitOrderTypeSchema,
    status: LimitOrderStatusSchema,
    walletId: Type.String(),
    walletAddress: Type.String(),
    amount: Type.String(),
    txSigned: Type.Optional(Type.String()),
    txSignature: Type.Optional(Type.String()),
    network: SupportedNetworkSchema,
    provider: SupportedDexSchema,
    tokenAddress: Type.String(),
    pairAddress: Type.String(),
    costAtCreationUsd: Type.String({
        description: 'Cost at creation in USD',
    }),
    costAtCreationNative: Type.String({
        description: 'Cost at creation in native currency',
    }),
    marketCapAtCreationUsd: Type.String({
        description: 'Market cap at creation in USD',
    }),
    swapSettings: TradeSettingsUnionSchema,
    createdAt: Type.String(),
    updatedAt: Type.String(),
    closedAt: Type.Optional(Type.String()),
    positionId: Type.Optional(Type.String()),
    deadlineMs: Type.Number(),
    deadlineAt: Type.String(),
    trigger: LimitOrderTriggerSchema,
});
//# sourceMappingURL=limit-order.js.map